function retrieveNotifyOnReturnVisitor(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/notify-on-return-visitor`);
}

function updateNotifyOnReturnVisitor(companyId, payload) {
    return window.tenantAxios.patch(`/company/${companyId}/notify-on-return-visitor`, payload);
}

export default {
    retrieveNotifyOnReturnVisitor,
    updateNotifyOnReturnVisitor,
};
